import { render } from "./ModalTools.vue?vue&type=template&id=1f0fad9a"
import script from "./ModalTools.vue?vue&type=script&lang=js"
export * from "./ModalTools.vue?vue&type=script&lang=js"

import "./ModalTools.vue?vue&type=style&index=0&id=1f0fad9a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__